"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQrCode = void 0;
var _qrCodeStyling = _interopRequireDefault(require("qr-code-styling"));
var _react = require("react");
var _contexts = require("../contexts");
var _utils = require("../utils");
var _useGetQrCodeOptions = require("./useGetQrCodeOptions");
const useQrCode = () => {
  const {
    url
  } = (0, _contexts.useQrCodeDialog)();
  const qrRef = (0, _react.useRef)(null);
  const qrCodeOptions = (0, _useGetQrCodeOptions.useGetQrCodeOptions)();
  const qrCode = (0, _react.useRef)(new _qrCodeStyling.default(qrCodeOptions)).current;
  (0, _react.useEffect)(() => {
    // istanbul ignore next @preserve -- not testable
    if (qrRef.current) {
      qrCode.append(qrRef.current);
    }
  }, [qrCode]);
  (0, _react.useEffect)(() => {
    const size = (0, _utils.getQrSize)(url);
    qrCode.update({
      ...qrCodeOptions,
      data: url,
      width: size,
      height: size
    });
  }, [qrCode, qrCodeOptions, url]);
  return {
    qrRef
  };
};
exports.useQrCode = useQrCode;
